import React from 'react';
import PropTypes from 'prop-types';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import Numeral from 'numeral';
import LikeIcon from './images/like.svg';
import ViewIcon from './images/view.svg';

const useStyles = makeStyles({
  root: {
    background: props => (props.imageError ? '#0000001A' : '#8A8A8A'),
    height: 39,
    width: '100%',
  },
  contentContainer: {
    height: '100%',
  },
  content: {
    color: props => (props.imageError ? '#4B4B4B' : '#fff'),
  },
  icon: {
    filter: props => props.imageError && 'invert(100%)',
  },
  textContainer: {
    gap: 15,
    paddingRight: 20,
  },
  custom: {
    height: 34,
  },
});
function VideoInfoCounter(props) {
  const {
    data: { youtubeLikeCount = 0, youtubeViewCount = 0 },
    imageError,
  } = props;

  const classes = useStyles({ imageError });
  return (
    <Grid item xs={12} className={classes.root}>
      <Grid
        container
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        className={classes.contentContainer}
      >
        <Grid item xs={12}>
          <Grid
            container
            direction="row"
            justifyContent="flex-end"
            alignItems="center"
            className={classes.textContainer}
          >
            <img src={LikeIcon} alt="Likes" className={classes.icon} />
            <Typography className={classes.content}>
              {Numeral(youtubeLikeCount).format('0a')}
            </Typography>
            <img src={ViewIcon} alt="Views" className={classes.icon} />
            <Typography className={classes.content}>
              {Numeral(youtubeViewCount).format('0a')}
            </Typography>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
}

VideoInfoCounter.propTypes = {
  data: PropTypes.object,
  imageError: PropTypes.bool,
};

export default VideoInfoCounter;
